import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    amount: "",
    currency: "",
    memo: "",
    invoice: null,
    otherDocument: null,
    provider: null,
    recipient: {
        name: "",
        accountNumber: "",
        bankName: "",
        userId: "",
    },
};

const tradevuTransferSlice = createSlice({
    name: "tradevuTransfer",
    initialState,
    reducers: {
        setAmount: (state, action) => {
            state.amount = action.payload;
        },
        setMemo: (state, action) => {
            state.memo = action.payload;
        },
        setInvoice: (state, action) => {
            state.invoice = action.payload;
        },
        setCurrency: (state, action) => {
            state.currency = action.payload;
        },
        setOtherDocument: (state, action) => {
            state.otherDocument = action.payload;
        },
        setProvider: (state, action) => {
            state.provider = action.payload;
        },
        setRecipient: (state, action) => {
            state.recipient = {
                ...state.recipient,
                ...action.payload,
            };
        },
        resetTransfer: () => initialState,
    },
});

export const {
    setAmount,
    setCurrency,
    setMemo,
    setInvoice,
    setOtherDocument,
    setProvider,
    setRecipient,
    resetTransfer,
} = tradevuTransferSlice.actions;

export default tradevuTransferSlice.reducer;
